import Button from '../../common/Button.component';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const ActionsButton = ({
  onClick,
  showAction,
  endIcon,
  variant = 'outlined',
}) => {
  return (
    <Button
      variant={variant}
      endIcon={
        endIcon ||
        (showAction ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />)
      }
      onClick={onClick}
      sx={{ width: { xs: 100, sm: 'auto' } }}
    >
      Actions
    </Button>
  );
};

export default ActionsButton;
